import { useEffect, useRef, useState } from 'react';

const ROLES = ['Cultural Historian', 'Archivist', 'Curator', 'Researcher'];

function AnimatedRoles() {
  const [displayed, setDisplayed] = useState('');
  const [roleIndex, setRoleIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [deleting, setDeleting] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    const current = ROLES[roleIndex];

    if (!deleting && charIndex <= current.length) {
      setDisplayed(current.slice(0, charIndex));
      timeoutRef.current = setTimeout(() => setCharIndex((c) => c + 1), 80);
    } else if (!deleting && charIndex > current.length) {
      timeoutRef.current = setTimeout(() => setDeleting(true), 1800);
    } else if (deleting && charIndex >= 0) {
      setDisplayed(current.slice(0, charIndex));
      timeoutRef.current = setTimeout(() => setCharIndex((c) => c - 1), 45);
    } else {
      setDeleting(false);
      setRoleIndex((r) => (r + 1) % ROLES.length);
      setCharIndex(0);
    }

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [charIndex, deleting, roleIndex]);

  return (
    <p className="font-sans text-sm uppercase tracking-[0.3em] text-white/60 mb-6 h-5">
      <span>{displayed}</span>
      <span className="inline-block w-px h-4 bg-white/50 ml-0.5 animate-pulse align-middle" />
    </p>
  );
}

export default function HeroSection() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center">
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/edited_554b7823461f6812ea5c30a8d3ea0940_6c28ab8c.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 lg:px-12 py-32 text-center">
        <AnimatedRoles />
        <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-8xl font-bold text-white leading-tight tracking-wide mb-8">
          OLUDAMOLA<br />ADEBOWALE
        </h1>
        <p className="font-sans text-lg text-white/75 leading-relaxed mb-12 max-w-2xl mx-auto">
          Dedicated to preserving and reinterpreting cultural heritage through rigorous research, thoughtful curation, and innovative archival practice. Bridging history and the present by transforming archives into living, accessible repositories for contemporary audiences.
        </p>
        <button
          onClick={() => scrollToSection('research')}
          className="mt-4 px-10 py-3 border border-white/80 text-white font-sans text-sm font-medium rounded-full hover:bg-white hover:text-gray-900 transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          Explore My Work
        </button>
      </div>
    </section>
  );
}
